import React, {FC} from 'react';
import { Button } from '@mui/material';
import { BookingCheckInVO } from "../../../types/model/valueObject/booking/BookingCheckInVO";
import { constructListingImageUrl } from "../../../util/ConstructImageUrlUtil";
import { ReportDialogSetterProps } from "../../../interfaces";
import { dialogs } from "./SupplierBookingCheckInDialogWrapper";
import {
  CardSubBodyContainer,
  CardContainer,
  CardHeaderItemContainer,
  CardHeaderTitleText,
  CardHeaderButtonContainer,
  CardBodyContainer,
  CardRowItemContainer,
  CardSubBodyContainerContentCentered,
} from "@securspace/securspace-ui-kit";
import {
  CardImageItem,
  CardSubBodyItem,
  CardHeaderContainerWarning
} from "../../cardComponents";

type SupplierBookingCheckInCardListItemProps = {
  item: BookingCheckInVO;
  onOpenDialog: (dialog: ReportDialogSetterProps<BookingCheckInVO>) => void;
}

/**
 * Component that displays all information for a single admin space usage item
 * @param item the BookingCheckInVO to display
 * @param onOpenDialog
 */
const SupplierBookingCheckInCardListItem: FC<SupplierBookingCheckInCardListItemProps> = ({
  item,
  onOpenDialog
}) => {

  const warningMessage = item && (item.numberOfSpaces <= item.locationInventoryCount) ? 'Booking at or above capacity!' : '';

  const handleCheckInAction = (e: React.MouseEvent<HTMLButtonElement>): void => {
    e.preventDefault();
    e.stopPropagation();
    onOpenDialog({ item, dialog: dialogs.CHECK_IN });
  };

  return (
    <CardContainer>
      <CardHeaderContainerWarning warningLevel={warningMessage ? 'warning' : 'none'}>
        <CardHeaderItemContainer>
          <CardHeaderTitleText>{`${item?.buyerCompanyName} - ${item?.locationName}`}</CardHeaderTitleText>
        </CardHeaderItemContainer>
        <CardHeaderItemContainer>
          {
            warningMessage && (
              <CardHeaderTitleText>{warningMessage}</CardHeaderTitleText>
            )
          }
        </CardHeaderItemContainer>
        <CardHeaderButtonContainer>
          <Button variant={'outlined'} onClick={handleCheckInAction}>Check In</Button>
        </CardHeaderButtonContainer>
      </CardHeaderContainerWarning>
      <CardBodyContainer>
        <CardRowItemContainer>
          <CardImageItem
            src={item?.locationImageFileName && constructListingImageUrl(item.locationImageFileName)}
            alt={item?.locationName || 'location'}
          />
        </CardRowItemContainer>
        <CardSubBodyContainer>
          <CardSubBodyContainerContentCentered>
            <CardSubBodyItem value={item?.buyerCompanyName} label={'Buyer'} />
            <CardSubBodyItem value={item?.bookingNumber} label={'Booking Number'} />
            <CardSubBodyItem value={item?.assetType} label={'Asset'} />
            <CardSubBodyItem value={item?.status} label={'Status'} />
            <CardSubBodyItem value={item?.dateRange} label={'Booked Dates'} />
            <CardSubBodyItem value={item?.numberOfSpaces} label={'Spaces Booked'} />
            <CardSubBodyItem value={item?.locationName} label={'Location'} />
          </CardSubBodyContainerContentCentered>
        </CardSubBodyContainer>
      </CardBodyContainer>
    </CardContainer>
  );
};

export { SupplierBookingCheckInCardListItem };
